jQuery.fn.favorites = function ( settings ) {
    var elem = this ;

    settings = jQuery.extend({
        classname: 'is-active' ,
        module: 'favorites' ,
        callback: function ( param , obj ) { }
    } , settings) ;

    return elem.each ( function () {
        var me     = this ;        
        var params = { ref_id:     $( this ).attr ( 'data-id' ), 
                       ref_module: $( this ).attr ( 'data-module' ), 
                       ref_action: $( this ).attr ( 'data-action' ) ? $( this ).attr ( 'data-action' ) : '', 
                       ref_group:  $( this ).attr ( 'data-group' ) ? $( this ).attr ( 'data-group' ) : '' } ;

        $( me ).click ( function () {
            if ( $( this ).hasClass ( settings.classname ) ) {
                var use_params = jQuery.extend ( { action: 'delete' } , params ) ;
            } else {
                var use_params = jQuery.extend ( { action: 'edit' , work_data: 'TRUE' } , params ) ;
            }

            dcg_ExecuteModule ( settings.module , use_params , function ( response ) {
                $( me ).replaceWith ( $( response ).favorites ( settings ) ) ;

                settings.callback ( use_params , me ) ;
            } ) ;

            return false ;
        } ) ;
    }) ;
};